import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isEntityAdded: false,
};

const thresholdForm = createSlice({
    name: 'thresholdForm',
    initialState,
    reducers: {
   
        handleItemAdded(state) {
            state.isEntityAdded = true;
       
        },
        changeIsItemAddedToFalse(state){
            state.isEntityAdded = false;
        }
        
       

    }
});

export const {handleItemAdded,changeIsItemAddedToFalse  } = thresholdForm.actions;

export default thresholdForm.reducer;